module.exports = __webpack_public_path__ + "static/media/icon-dev-2.68cd7114.svg";